(function(){
    angular
        .module('app')
        .directive('ngFinscroll', finscroll);

        finscroll.$inject = ['$timeout'];
        function finscroll($timeout){
             return function(scope, elm, attr) {
			    var raw = elm[0];

			    elm.bind('scroll', function() {
			      if (raw.scrollTop + raw.offsetHeight +1 >= raw.scrollHeight) {
			        scope.$apply(attr.ngFinscroll);
			      }
			    });
			  };
      	}
})();